exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".qa-text{font-size:1.2rem;line-height:1.8;padding-left:10px}.h5,h5{font-size:1.5rem;font-weight:600}", ""]);

